import { Checkbox } from '@kurtosys/ksys-app-components/dist/components/base/Checkbox/Checkbox';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Checkbox, 'app', ['checkbox']);
